import { takeLatest } from "redux-saga/effects";
import { appActions } from "./appSlice";
import { removeToken, storeToken } from "@/sideEffects/persist/authSideEffects";
import { removeFirm, storeFirm } from "@/sideEffects/persist/firmSideEffects";

// eslint-disable-next-line require-yield
function* handleSuccessfulLogin({ payload }: ReturnType<typeof appActions.successfulLogin>) {
  storeToken(payload.token);
}

// eslint-disable-next-line require-yield
function* handleTriggerLogout() {
  removeToken();
  removeFirm();
}

// eslint-disable-next-line require-yield
function* handleSetActiveFirm({ payload }: ReturnType<typeof appActions.setActiveFirm>) {
  storeFirm(payload);
}

export function* appSaga() {
  yield takeLatest(appActions.successfulLogin, handleSuccessfulLogin);
  yield takeLatest(appActions.triggerLogout, handleTriggerLogout);
  yield takeLatest(appActions.setActiveFirm, handleSetActiveFirm);
}
